





































import { Button } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import Payment from '@/models/payment'

import { longDateFormat } from '@/globalFilters'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class SuccessPaymentTab extends Vue {
  @Prop() payment!: Payment
  @Prop({ default: true }) printable!: boolean

  dateFormat = longDateFormat
}
